import { useFormContext } from 'react-hook-form';
import { FaUserTie, FaShoppingCart, FaUser, FaBuilding, FaCheckCircle } from 'react-icons/fa';
import { useLanguage } from '../../../../context/LanguageContext';

export default function Step1UserAndAccountType({ onSelectUserType }) {
  const { watch, setValue } = useFormContext();
  const userType = watch('userType');
  const accountType = watch('accountType');
  const { translate } = useLanguage();

  return (
    <div className="space-y-8 transition-all duration-500">
      {/* SECTION 1: CHOOSE ROLE */}
      <div className="space-y-6">
        <div className="text-center">
          <h3 className="text-2xl text-white font-bold">{translate("auth.signup.chooseRole")}</h3>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <UserCard
            icon={<FaShoppingCart size={28} />}
            label={translate("auth.signup.buyer")}
            active={userType === 'buyer'}
            onClick={() => onSelectUserType('buyer')}
          />
          <UserCard
            icon={<FaUserTie size={28} />}
            label={translate("auth.signup.seller")}
            active={userType === 'seller'}
            onClick={() => onSelectUserType('seller')}
          />
        </div>
      </div>

      {/* SECTION 2: ACCOUNT TYPE (Conditionally Rendered with Animation) */}
      <div 
        className={`transition-all duration-700 ease-in-out overflow-hidden ${
          userType ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0 pointer-events-none'
        }`}
      >
        <div className="pt-8 border-t border-gray-800 space-y-6">
          <div className="text-center">
            <h3 className="text-xl text-white font-bold">{translate("auth.signup.accountType")}</h3>
            <p className="text-gray-400 text-sm">{translate("auth.signup.howRegistering")}</p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <UserCard
              icon={<FaUser size={26} />}
              label={translate("auth.signup.individual")}
              active={accountType === 'individual'}
              onClick={() => setValue('accountType', 'individual', { shouldValidate: true })}
            />
            <UserCard
              icon={<FaBuilding size={26} />}
              label={translate("auth.signup.corporate")}
              active={accountType === 'corporate'}
              onClick={() => setValue('accountType', 'corporate', { shouldValidate: true })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function UserCard({ icon, label, active, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`relative cursor-pointer border-2 rounded-2xl p-6 flex flex-col items-center gap-3 transition-all duration-300 transform active:scale-95
        ${active 
          ? 'border-blue-500 bg-blue-500/10 shadow-[0_0_15px_rgba(59,130,246,0.2)]' 
          : 'border-gray-700 bg-gray-800/20 hover:border-gray-500 hover:bg-gray-800/40'
        }
      `}
    >
      {active && (
        <FaCheckCircle className="absolute top-3 right-3 text-blue-500 animate-in zoom-in duration-300" size={18} />
      )}
      <div className={`transition-colors duration-300 ${active ? 'text-blue-400' : 'text-gray-400'}`}>
        {icon}
      </div>
      <span className={`font-bold tracking-wide ${active ? 'text-white' : 'text-gray-300'}`}>
        {label}
      </span>
    </div>
  );
}

// import { useFormContext } from 'react-hook-form';
// import { FaUserTie, FaShoppingCart, FaUser, FaBuilding } from 'react-icons/fa';
// import { useLanguage } from '../../../../context/LanguageContext';

// export default function Step1UserAndAccountType({ onSelectUserType }) {
//   const { watch, setValue } = useFormContext();
//   const userType = watch('userType');
//   const accountType = watch('accountType');
//   const { translate } = useLanguage();

//   return (
//     <div className="space-y-8">

//       {/* USER TYPE */}
//       <div className="text-center">
//         <h3 className="text-2xl text-white font-bold">{translate("auth.signup.chooseRole")}</h3>
//         <p className="text-white"></p>
//       </div>

//       <div className="grid grid-cols-2 gap-4">
//         <UserCard
//           icon={<FaShoppingCart size={28} />}
//           label={translate("auth.signup.buyer")}
//           active={userType === 'buyer'}
//           onClick={() => {
//             onSelectUserType('buyer');
//           }}
//         />
//         <UserCard
//           icon={<FaUserTie size={28} />}
//           label={translate("auth.signup.seller")}
//           active={userType === 'seller'}
//           onClick={() => {
//             onSelectUserType('seller');
//           }}
//         />
//       </div>

//       {/* ACCOUNT TYPE – SHOW ONLY AFTER USER TYPE */}
//       {userType && (
//         <>
//           <div className="text-center pt-6">
//             <h3 className="text-xl text-white font-bold">{translate("auth.signup.accountType")}</h3>
//             <p className="text-white">{translate("auth.signup.howRegistering")}</p>
//           </div>

//           <div className="grid grid-cols-2 gap-4">
//             <UserCard
//               icon={<FaUser size={26} />}
//               label={translate("auth.signup.individual")}
//               active={accountType === 'individual'}
//               onClick={() => setValue('accountType', 'individual', { shouldValidate: true })}
//             />
//             <UserCard
//               icon={<FaBuilding size={26} />}
//               label={translate("auth.signup.corporate")}
//               active={accountType === 'corporate'}
//               onClick={() => setValue('accountType', 'corporate', { shouldValidate: true })}
//             />
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// function UserCard({ icon, label, active, onClick }) {
//   return (
//     <div
//       onClick={onClick}
//       className={`cursor-pointer border-2 rounded-xl p-6 flex flex-col items-center gap-3 transition-all
//         ${active ? 'border-primary ' : 'border-gray-200 hover:border-primary-dark'}
//       `}
//     >
//       <div className={`${active ? 'text-primary' : 'text-white'}`}>
//         {icon}
//       </div>
//       <span className="font-semibold">{label}</span>
//     </div>
//   );
// }
